<template>
  <div class="box">
    <div class="content-warp main-width">
      <Breadcrumb />
      <div class="userInfo">
        <img :src="agencyInfo.unitLogo || defaultAvatar" alt="" />
        <div class="leftuser" style="width: 100%">
          <p>{{ agencyInfo.unitName }}</p>
          <div class="info">
            {{$t('简称')}}：{{ agencyInfo.abbreviation }}（{{$t('注：简称将用于对战的队伍信息展示')}}）
            <span class="edit" @click="$refs.editAgency.show(agencyInfo)">
              {{$t('修改资料')}} <a-icon type="right"
            /></span>
          </div>
        </div>
      </div>
      <a-menu v-model="current" mode="horizontal" style="border-radius: 5px;">
        <a-menu-item key="CenterAuth" v-if="agencyInfo.isMain === 1"><router-link :to="{path:'/CenterAgency', query:{agencyId: agencyInfo.agencyId, step: 'CenterAuth'}}">{{$t('授权管理')}}</router-link></a-menu-item>
        <a-menu-item v-for="item in menuList" :key="item.url"><router-link :to="{path:'/CenterAgency', query:{agencyId: agencyInfo.agencyId, step: item.url}}">{{ $t(item.name) }}</router-link></a-menu-item>
      </a-menu>
      <CenterAuth v-if="$route.query.step === 'CenterAuth'"/>
      <CenterPlayer v-if="$route.query.step === 'CenterPlayer'"/>
      <CenterCoach v-if="$route.query.step === 'CenterCoach'"/>
      <CenterTeam v-if="$route.query.step === 'CenterTeam'"/>
    </div>
    <EditAgency ref="editAgency" @ok="refreshAgency"/>
  </div>
</template>
<script>
import store from '@/store'
import matchFun from '@comm/utils/matchFun'
import Breadcrumb from '@comm/components/center/Breadcrumb'
import CenterAuth from '@comm/components/center/CenterAuth'
import CenterPlayer from '@comm/components/center/CenterPlayer'
import CenterCoach from '@comm/components/center/CenterCoach'
import CenterTeam from '@comm/components/center/CenterTeam'
import EditAgency from '@comm/components/modal/EditAgency'
import { mapState } from 'vuex'
export default {
  name: 'Index',
  components: {
    Breadcrumb,
    CenterAuth,
    CenterPlayer,
    CenterCoach,
    CenterTeam,
    EditAgency
  },
  mounted () {
    this.current = [this.$route.query.step]
    this.queryProgram()
    // 授权机构
    if (this.agencyInfo.isMain === 0) {
      this.permission()
    } else {
      this.menuList = this.matchFun.centerMenuList(false)
    }
  },
  data () {
    return {
      matchFun: matchFun,
      defaultAvatar: require('../../assets/userdef.png'),
      myAgencys: [],
      entitledAgencys: [],
      menuList: [],
      current: ['CenterAuth']
    }
  },
  computed: {
    ...mapState({
      agencyInfo: state => state.agency.agencyInfo
    })
  },
  methods: {
    queryProgram () {
      this.$api.match.programAll({}).then(res => {
        if (res.status === 0) {
          let arr = []
          res.data.forEach(element => {
            arr.push({
              programId: element.id,
              name: element.name
            })
          })
          store.commit('agency/MATCH_CHANGE_AGENCY_PROGRAM', arr)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    permission () {
      this.$api.high.agencyPermission({agencyId: this.agencyInfo.agencyId}).then(res => {
        if (res.status === 0) {
          if (res.data.length > 0) {
            res.data.forEach(element => {
              if (element.permKey !== null) {
                this.menuList.push({
                  name: this.matchFun.menuNameByCode(element.permKey),
                  url: element.permKey
                })
              }
            })
            this.current = [this.menuList[0].url]
            this.$router.push({path: '/CenterAgency', query: {agencyId: this.agencyInfo.agencyId, step: this.menuList[0].url}})
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    refreshAgency (item) {
      store.commit('agency/MATCH_CHANGE_AGENCY_INFO', item)
    }
  }
}
</script>
<style lang="scss" scoped>
.box {
  background: #f0f1f2;
}
.main-width {
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.content-warp{
  padding: 10px 0;
  min-height: 600px;
}
.userInfo {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 20px;
  margin: 10px 0;
  border-radius:5px;
  img {
    width: 70px;
    height: 70px;
    border-radius: 35px;
    margin-right: 20px;
  }
  .leftuser {
    p {
      font-weight: 600;
      margin-bottom: 8px;
      font-size: 18px;
      display: inline-block;
    }

    .info {
      position: relative;
      span {
        margin: 0 3px;
      }
      .edit {
        position: absolute;
        color: #43a3ff;
        cursor: pointer;
      }
    }
  }
}
.agencyBox {
  background: #fff;
  border-radius:5px;
  margin-bottom: 10px;
  display: flex;
  padding: 20px;
  flex-wrap: wrap;
  justify-content: space-between;
  .agencyCrad {
    width: 560px;
    background-color: #fff;
    box-shadow: 0px 0px 3px 1px #dbdbdb;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    padding: 20px 35px;
    margin-bottom: 20px;
    .craditem {
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: space-between;
      .cradflex {
        display: flex;
        align-items: center;
        img {
          width: 75px;
          height: 75px;
          margin-right: 15px;
          border-radius: 50%;
        }
        .title {
          font-size: 18px;
          font-weight: 600;
          color: #333333;
        }
      }
      .icon {
        font-size: 20px;
        color: #dbdbdb;
      }
    }
  }
}
.nodata {
  background: #fff;
  border-radius:5px;
  padding: 20px;
  text-align: center;
  margin-bottom: 10px;
  .text {
    color: #999;
    margin: 20px;
  }
}
.vip {
  padding: 5px 10px;
  color: #fff;
  background-image: linear-gradient(to right, #f0c688, #a97b39);
  border-radius: 13px;
  font-size: 10px;
  vertical-align: text-bottom;
  margin-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/components/center/Agency.vue